import { render, staticRenderFns } from "./AS_Testimonial.vue?vue&type=template&id=50490797&scoped=true&"
import script from "./AS_Testimonial.vue?vue&type=script&lang=js&"
export * from "./AS_Testimonial.vue?vue&type=script&lang=js&"
import style0 from "./AS_Testimonial.vue?vue&type=style&index=0&id=50490797&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50490797",
  null
  
)

export default component.exports